// src/components/CategorySection.js
import React from 'react';
import '../../style/components/FormView.css';  
const CategorySection = ({ title, links = [] }) => {  // Default empty array if links are undefined
    return (
      <section className="category-section">
        <h2>{title}</h2>
        <div className="form-links">
          {links.length > 0 ? (
            links.map((link, index) => (
              <a href={link.href} className="form-link" key={index}>
                {link.text}
              </a>
            ))
          ) : (
            <p>No links available.</p>  // Display this if no links are provided
          )}
        </div>
      </section>
    );
  };
  
  export default CategorySection;